import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import Vuex from 'vuex'
import * as echarts from 'echarts'
import "swiper/swiper.min.css"
import '@/utils/flexible'
import VueI18n from 'vue-i18n'
import LangENUS from './common/lang/en-us'
import LangZHCN from './common/lang/zh-cn'

Vue.use(Antd)
Vue.use(VueI18n)
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
Vue.prototype.toAsk = function () {
  window.open('https://affim.baidu.com/unique_33177294/chat?siteId=19276438&userId=33177294&siteToken=d33cedbee9df50747590021c01666200', '_blank')
}
Vue.use(Vuex)

const i18n = new VueI18n({
  locale: 'zh-cn',
  messages: {
    'en-us': LangENUS,
    'zh-cn': LangZHCN
  }
})


new Vue({
  router,
  store,  
  i18n,
  render: h => h(App)
}).$mount('#app')
